// Categorias y agrupacion de servicios usadas en los flujos de reserva
// (modal y pagina /reservar). Los precios y nombres se traen en vivo desde
// el catalogo real (tabla Servicios, la misma que edita Cata en el panel
// admin), asi nunca se desincronizan.

// Orden en el que se muestran las categorias en el paso 1 de la reserva.
export const CATEGORIAS_RESERVA = [
  { id: "manos", nombre: "Manicuría" },
  { id: "pies", nombre: "Pedicuría" },
  { id: "pestanas", nombre: "Pestañas" },
  { id: "otros", nombre: "Otros servicios" },
];

// Nombre de la tarjeta unificada que agrupa todos los mantenimientos de
// pestañas dentro de "Otros servicios".
const _NOMBRE_GRUPO_MANTENIMIENTO = "Mantenimiento";

// Quita el "Talle X" del final de un nombre, para que todos los talles de
// un mismo servicio (ej. Soft Gel Talle S / M / L / XL) se agrupen bajo una
// sola tarjeta ("Soft Gel") y los talles queden como variantes a elegir.
function nombreBase(nombre) {
  return nombre.replace(/\s+Talle\s+.+$/i, "").trim();
}

// Agrupa el catalogo de una categoria por nombre base de servicio, juntando
// las variantes (talles, o detalles como Liso / Diseño Glow) bajo el mismo
// nombre. Nunca incluye servicios marcados como no disponibles para reserva
// online. En "Otros servicios" ademas se agrega una tarjeta "Mantenimiento"
// que reune todos los mantenimientos de pestañas como variantes a elegir.
export function agruparServiciosPorNombre(catalogo, categoriaId) {
  const _filtrados = catalogo
    .filter((s) => s.categoria === categoriaId && s.disponibleParaReserva !== false)
    .slice()
    .sort((a, b) => a.orden - b.orden);

  const _agrupado = [];

  _filtrados.forEach((servicio) => {
    const _nombreGrupo = nombreBase(servicio.nombre);
    const _grupo = _agrupado.find((g) => g.nombre === _nombreGrupo);
    if (_grupo) {
      _grupo.variantes.push(servicio);
    } else {
      _agrupado.push({ nombre: _nombreGrupo, variantes: [servicio] });
    }
  });

  if (categoriaId === "otros") {
    const _mantenimientos = catalogo
      .filter((s) => s.categoria === "mantenimientos" && s.disponibleParaReserva !== false)
      .slice()
      .sort((a, b) => a.orden - b.orden);

    if (_mantenimientos.length > 0) {
      _agrupado.push({ nombre: _NOMBRE_GRUPO_MANTENIMIENTO, variantes: _mantenimientos });
    }
  }

  return _agrupado;
}

// Etiqueta a mostrar para una variante dentro del paso de "elegir variante"
// de un grupo (por ejemplo "Talle S - Diseño Glow" para Soft Gel, o
// "Pelo a pelo / clásicas - hasta 2 semanas" dentro de "Mantenimiento").
export function etiquetaVariante(variante, nombreGrupo) {
  if (variante.nombre === nombreGrupo) {
    return variante.detalle || variante.nombre;
  }

  if (variante.nombre.startsWith(nombreGrupo)) {
    const _sufijo = variante.nombre.slice(nombreGrupo.length).trim();
    return variante.detalle ? `${_sufijo} - ${variante.detalle}` : _sufijo;
  }

  // El grupo reune servicios con nombres distintos (ej. "Mantenimiento").
  return variante.detalle ? `${variante.nombre} - ${variante.detalle}` : variante.nombre;
}

// Nombre completo para mostrar/guardar un turno, incluyendo el detalle de
// la variante elegida (por ejemplo "Soft Gel Talle S (Diseño Glow)").
export function nombreCompletoServicio(variante) {
  return variante.detalle ? `${variante.nombre} (${variante.detalle})` : variante.nombre;
}
